<template>
	<div class="role-items-wrapper">
		<div v-for="(category, key) in Items" class="w5-role-wrapper">
			<div class="w5-role-item-name">
				<span :title="selectStatus(key, category) | ftc" @click="selectDeselect($event, key, category)">{{ category.name | ftc }}</span>
			</div>
			<div class="w5-role-item-value">
				<div v-for="(role, action) in category.roles" class="w5-checkbox">
					<label class="checkbox-inline">
						<input type="checkbox" :value="key + '/' + action" v-model="checkValues"> {{ role | ftc }}
					</label>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'userRoleComponent',
	//=========================================================================
	// свойства, которые пришли от родителя
	//=========================================================================
	props: ['title', 'name', 'value', 'master', 'slave'],
	//=========================================================================
	// свои свойства компонента
	//=========================================================================
	data() {
		return {
			Items: {},
			checkValues: []
		}
	},
	//=========================================================================
	// компонент создан
	//=========================================================================
	created() {
		// основные категории
		if (this.master && typeof this.master === 'object' && Object.keys(this.master).length)
		{
			this.Items = Object.assign({}, this.master)
		}

		// действия над категориями
		if (this.slave && typeof this.slave === 'object' && Object.keys(this.slave).length)
		{
			// переработаем список ролей
			for (let role in this.slave) if (this.slave.hasOwnProperty(role))
			{
				// получим мастера
				let _parts = role.split('/')
				let _master = _parts[0]
				if (!_master || !_parts[1]) continue

				// заводим список только если есть такая категория
				if (this.Items[_master] && this.Items[_master]['actions'][_parts[1]])
				{
					// если еще нет списка
					if (!('roles' in this.Items[_master])) this.Items[_master]['roles'] = {}

					// добавляем действие в список
					this.Items[_master]['roles'][_parts[1]] = this.Items[_master]['actions'][_parts[1]]
				}
			}
		}

		// значения
		if (this.value && Array.isArray(this.value) && this.value.length)
			this.checkValues = this.value
	},
	//=========================================================================
	// локальные методы формы
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// текущий статус поля с чекбоксами
		//---------------------------------------------------------------------
		selectStatus(name, role) {
			// если есть хотя бы одно значение в массиве значений
			let _isValue = false
			if (role && role['actions'])
			{
				for (let action in role['actions'])
				{
					// значение
					let _value = name + '/' + action
					// ищем в массиве
					if (this.checkValues.indexOf(_value) > -1)
					{
						_isValue = true
						break
					}
				}
			}

			return _isValue ? 'main/deselect_all' : 'main/select_all'
		},
		//---------------------------------------------------------------------
		// клик по наименованию
		//---------------------------------------------------------------------
		selectDeselect(e, name, role) {
			// эмуляция фокуса
			this.$emit('focus')

			if (role && role['actions'])
			{
				// вычисляем еще раз статус
				let _status = this.selectStatus(name, role)
				// теперь в зависимости от статуса - правим массив значений
				for (let action in role['actions'])
				{
					// значение
					let _value = name + '/' + action
					// позиция значения в массиве
					let _idx = this.checkValues.indexOf(_value)

					// нужно убрать из массива такие значения
					if (_status === 'main/deselect_all')
					{
						// если такое значение есть
						if (_idx > -1) this.checkValues.splice(_idx, 1)
					}
					// нужно добавить все значения в массив значений
					else if (_status === 'main/select_all')
					{
						// если еще нет в массиве
						if (_idx < 0) this.checkValues.push(_value)
					}
				}
			}
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// наблюдатель
	//=========================================================================
	watch: {
		checkValues(values) {
			this.$emit('focus')
			this.$emit('input', values)
		}
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.role-items-wrapper {
	border: 1px solid #ddd;
	border-radius: 4px;
	padding: 15px 10px 0 14px;
	margin: 10px 10px 20px 0;
}
</style>



// WEBPACK FOOTER //
// role.vue?7d00921e